'use strict';

function Bridge() {}

var pushBack = require('./push-back.js');
Bridge.prototype.pushBack = Bridge.pushBack = pushBack;
Bridge.prototype.setTitle = Bridge.setTitle = function(title, subtitle) {
    pushBack('bridge:', 'set_webview_title', {
        title: title,
        subtitle: subtitle
    });
};

module.exports = Bridge;



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/legency-lvyou/index.js
// module id = 185
// module chunks = 0 8 9